// extracted by mini-css-extract-plugin
module.exports = {"tableContents":"_table_tableContents__hVPq2","H2":"_table_H2__8pulu","H3":"_table_H3__Jvh5p","active":"_table_active__AG_Gn"};